/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PublishedInputs */

const en_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

const es_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado`)
};

const fr_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publiée`)
};

const de_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlicht`)
};

const ja_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開中`)
};

const zh_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发布`)
};

const ar_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منشور`)
};

const id_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diterbitkan`)
};

const it_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicato`)
};

const ru_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликовано`)
};

const pt_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado`)
};

const ko_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게시됨`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {PublishedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const published = /** @type {((inputs?: PublishedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PublishedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_published(inputs)
	if (locale === "es") return es_published(inputs)
	if (locale === "fr") return fr_published(inputs)
	if (locale === "de") return de_published(inputs)
	if (locale === "ja") return ja_published(inputs)
	if (locale === "zh") return zh_published(inputs)
	if (locale === "ar") return ar_published(inputs)
	if (locale === "id") return id_published(inputs)
	if (locale === "it") return it_published(inputs)
	if (locale === "ru") return ru_published(inputs)
	if (locale === "pt") return pt_published(inputs)
	return ko_published(inputs)
});